export default __webpack_public_path__ + "static/media/flag.b96fb05b.svg";